module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pedido/costo-envio/costo-envio/costo-envio.component.html
// module id = ./src/app/pedido/costo-envio/costo-envio/costo-envio.component.html
// module chunks = main